import { SvgIcon } from '@mui/material';
import { Component } from 'react';

export default class LogoPJeSimbolo extends Component {
    render() {
        return (
            <SvgIcon
                viewBox="0 0 132.56 82.7"
                preserveAspectRatio="xMidYMid meet"
                {...this.props}
            >
                <path
                    fill="#3e3f3f"
                    d="M59.48,34c0,6.84-4,13.49-13.24,13.49H36.66v8.41A6.68,6.68,0,0,1,30,62.61h-.77V23.43a2.88,2.88,0,0,1,2.88-2.88H46.24c9.28,0,13.24,6.77,13.24,13.49M52,34c0-3.3-1.71-6.84-6-6.84h-9.4V40.81h9.21c4.4,0,6.17-3.35,6.17-6.77"
                />
                <path
                    fill="#3e3f3f"
                    d="M52,60.19h0a5.27,5.27,0,0,1,5.26-4.7h0c4.34,0,6-3.11,6-6.84V28a7.45,7.45,0,0,1,7.45-7.45v28.1c0,7.51-3.6,14-13.43,14a21.7,21.7,0,0,1-3.87-.52A1.79,1.79,0,0,1,52,60.19"
                />
                <path
                    fill="#e9571e"
                    d="M103.91,42.12h-22c.8,4,3.85,6,8.06,6a10.15,10.15,0,0,0,6.25-2,2.84,2.84,0,0,1,3.48,0,3.21,3.21,0,0,1,.08,5,16.17,16.17,0,0,1-10.18,3.39c-8.54,0-15-6-15-14.9,0-9.09,6.83-14.83,15-14.83s14.59,5.68,14.59,14.59a24.38,24.38,0,0,1-.18,2.75M97,37.17c-.43-3.9-3.42-6.16-7.38-6.16s-6.9,1.83-7.76,6.16Z"
                />
            </SvgIcon>
        );
    }
}
